import React from 'react';
import { Box } from '@mui/material';
import { MUSEFLOW_ORANGE, MUSEFLOW_OFF_WHITE_1 } from 'Components/Colors';

type LastUsedBadgeProps = {
  /**
   * `inline` - clay text tag that lives inside a method button (Google/Apple).
   * `chip`   - bordered pill, used as an adornment on the email field.
   */
  variant?: 'inline' | 'chip';
  /** Style overrides for placement in a specific context. */
  sx?: object;
};

/**
 * A "Last used" hint shown on the sign-in method the user last signed in with
 * on this device. Text label (never colour as the sole signal).
 */
const LastUsedBadge: React.FC<LastUsedBadgeProps> = ({ variant = 'chip', sx }) => {
  if (variant === 'inline') {
    return (
      <Box
        component="span"
        role="status"
        aria-label="Last used sign-in method"
        sx={{
          fontFamily: 'Lato',
          fontSize: '11px',
          fontWeight: 700,
          color: MUSEFLOW_ORANGE,
          whiteSpace: 'nowrap',
          ...sx,
        }}
      >
        &nbsp;&middot; Last used
      </Box>
    );
  }

  return (
    <Box
      component="span"
      role="status"
      aria-label="Last used sign-in method"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        fontFamily: 'Lato',
        fontSize: '10px',
        fontWeight: 700,
        lineHeight: 1,
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        color: MUSEFLOW_OFF_WHITE_1,
        border: `1px solid ${MUSEFLOW_ORANGE}`,
        borderRadius: '40px',
        padding: '2px 7px',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      Last used
    </Box>
  );
};

export default LastUsedBadge;
